// Constants for a-law
const SIGN_BIT_A = 0x80
const QUANT_MASK_A = 0x0f
const SEG_SHIFT_A = 0x04
const SEG_MASK_A = 0x70
const seg_end_A = new Uint16Array([0xff, 0x1ff, 0x3ff, 0x7ff, 0xfff, 0x1fff, 0x3fff, 0x7fff])

// Constants for u-law
const SIGN_BIT_U = 0x80
const QUANT_MASK_U = 0x0f
const SEG_SHIFT_U = 0x04
const SEG_MASK_U = 0x70
const BIAS = 0x84
const seg_end_U = new Uint16Array([0xff, 0x1ff, 0x3ff, 0x7ff, 0xfff, 0x1fff, 0x3fff, 0x7fff])

// Utility function to search in segment table
function search(val, table, size) {
  for (let i = 0; i < size; i++) {
    if (val <= table[i]) return i
  }
  return size
}

// Convert linear PCM to a-law
function linear2alaw(pcm_val) {
  let mask, seg, aval
  if (pcm_val >= 0) {
    mask = 0xd5 // sign bit = 1
  } else {
    mask = 0x55 // sign bit = 0
    pcm_val = -pcm_val - 8
  }
  seg = search(pcm_val, seg_end_A, 8)
  if (seg >= 8) {
    return 0x7f ^ mask
  } else {
    aval = seg << SEG_SHIFT_A
    if (seg < 2) {
      aval |= (pcm_val >> 4) & QUANT_MASK_A
    } else {
      aval |= (pcm_val >> (seg + 3)) & QUANT_MASK_A
    }
    return aval ^ mask
  }
}

// Convert a-law to linear PCM
function alaw2linear(a_val) {
  let t, seg
  a_val ^= 0x55
  t = (a_val & QUANT_MASK_A) << 4
  seg = (a_val & SEG_MASK_A) >> SEG_SHIFT_A
  switch (seg) {
    case 0:
      t += 8
      break
    case 1:
      t += 0x108
      break
    default:
      t += 0x108
      t <<= seg - 1
  }
  return a_val & SIGN_BIT_A ? t : -t
}

// Convert PCM array to a-law array
function alawFromPCM(data) {
  let dest = new Uint8Array(data.length)
  for (let i = 0; i < data.length; i++) {
    dest[i] = linear2alaw(data[i])
  }
  return dest
}

// Convert a-law array to PCM
function alawToPCM(data, bit = 16) {
  const TypedArray = bit === 16 ? Int16Array : Int8Array
  let dest = new TypedArray(data.length)
  for (let i = 0; i < data.length; i++) {
    dest[i] = alaw2linear(data[i] & 0xff)
  }
  return dest
}

// Convert linear PCM to u-law
function linear2ulaw(pcm_val) {
  let mask, seg, uval
  if (pcm_val < 0) {
    pcm_val = BIAS - pcm_val
    mask = 0x7f
  } else {
    pcm_val += BIAS
    mask = 0xff
  }
  seg = search(pcm_val, seg_end_U, 8)
  if (seg >= 8) {
    return 0x7f ^ mask
  } else {
    uval = (seg << 4) | ((pcm_val >> (seg + 3)) & 0xf)
    return uval ^ mask
  }
}

// Convert u-law to linear PCM
function ulaw2linear(u_val) {
  u_val = ~u_val
  let t = ((u_val & QUANT_MASK_U) << 3) + BIAS
  t <<= (u_val & SEG_MASK_U) >>> SEG_SHIFT_U
  return u_val & SIGN_BIT_U ? BIAS - t : t - BIAS
}

// Convert PCM array to u-law array
function ulawFromPCM(data) {
  let dest = new Uint8Array(data.length)
  for (let i = 0; i < data.length; i++) {
    dest[i] = linear2ulaw(data[i])
  }
  return dest
}

// Convert u-law array to PCM
function ulawToPCM(data, bit = 16) {
  const TypedArray = bit === 16 ? Int16Array : Int8Array
  let dest = new TypedArray(data.length)
  for (let i = 0; i < data.length; i++) {
    dest[i] = ulaw2linear(data[i] & 0xff)
  }
  return dest
}

// Encode WAV file header
function encodeWAV(
  bytes,
  sampleRate = 44100,
  numChannels = 2,
  sampleBits = 16,
  littleEndian = true
) {
  let buffer = new ArrayBuffer(44 + bytes.byteLength),
    data = new DataView(buffer),
    offset = 0

  // Write RIFF header
  writeString(data, offset, 'RIFF')
  offset += 4
  data.setUint32(offset, 36 + bytes.byteLength, littleEndian) // total length
  offset += 4
  writeString(data, offset, 'WAVE')
  offset += 4

  // Write format chunk
  writeString(data, offset, 'fmt ')
  offset += 4
  data.setUint32(offset, 16, littleEndian) // size of format chunk
  offset += 4
  data.setUint16(offset, 1, littleEndian) // format (1 = PCM)
  offset += 2
  data.setUint16(offset, numChannels, littleEndian) // channels
  offset += 2
  data.setUint32(offset, sampleRate, littleEndian) // sample rate
  offset += 4
  data.setUint32(offset, sampleRate * numChannels * (sampleBits / 8), littleEndian) // byte rate
  offset += 4
  data.setUint16(offset, numChannels * (sampleBits / 8), littleEndian) // block align
  offset += 2
  data.setUint16(offset, sampleBits, littleEndian) // bits per sample
  offset += 2

  // Write data chunk
  writeString(data, offset, 'data')
  offset += 4
  data.setUint32(offset, bytes.byteLength, littleEndian) // data length
  offset += 4

  // Copy PCM data
  for (let i = 0; i < bytes.byteLength; i++) {
    data.setUint8(offset++, bytes.getUint8(i))
  }

  return buffer
}

// Utility function to write a string into the DataView
function writeString(view, offset, string) {
  for (let i = 0; i < string.length; i++) {
    view.setUint8(offset + i, string.charCodeAt(i))
  }
}

// Export functions
export { alawFromPCM, alawToPCM, ulawFromPCM, ulawToPCM, encodeWAV }
